import type { EventBusPayload, EventHandler } from "./event-bus.type";

import { useEffect, useRef } from "react";

import { useEventBus } from "./event-bus.context";

export function useEventBusListener(event: string, handler: EventHandler) {
  const bus = useEventBus();
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  });

  useEffect(() => {
    const wrapped = (payload: EventBusPayload) => handlerRef.current(payload);
    bus.on(event, wrapped);
    return () => bus.off(event, wrapped);
  }, [bus, event]);
}
